import clickUtils from "./clickUtils";
import promotionPieces from "./promotionPieces";

const standardChess = {
  clickUtils,
  promotionPieces,
};

export default standardChess;